/**
 * 혜택명 규칙 — 목록(플레이스홀더)·정보 팝업·저장 화면(검증)이 **같은 기준**을 쓴다.
 * 서버 `BenefitValidator.requireBenefitName` 의 거울: 공백만 있어도 빈 것이다.
 *
 * 배경(2026-11-03): 입력란의 `*` 만 있고 검사가 없어 운영에 이름 없는 혜택 10건이 생겼고,
 * 목록에서 혜택명 클릭 면적이 0 이라 옆 메뉴 '수정하기' 로만 들어갈 수 있었다.
 */

/** 혜택명이 비었는지. `null`/`undefined`/`""`/공백만 → true. */
export const isBlankName = (name) => name == null || String(name).trim() === ""

export const BLANK_NAME_PLACEHOLDER = "(이름 없음)"

/** 목록·팝업 표시용. 비면 플레이스홀더(글자가 있어야 클릭 면적이 생긴다). */
export const displayBenefitName = (name) => (isBlankName(name) ? BLANK_NAME_PLACEHOLDER : name)

/** 저장 화면 검증 문구. 서버 400 문구와 같은 뜻으로 맞춘다(임시저장도 필수). */
export const BLANK_NAME_MESSAGE = "혜택명을 입력해 주세요. 임시저장도 혜택명이 필요합니다."
